module.exports = __webpack_public_path__ + "static/media/fig_20a.f0597fe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_20a.jpg
// module id = 654
// module chunks = 0